<template>
  <section class="py-12 lg:py-16">
    <div class="mx-auto max-w-[900px] px-4">
      <h2 class="landing_h2 mb-4 text-center">
        <Translate translate-key="landing_legality.title" />
      </h2>
      <h3 class="mb-10 text-center text-2xl font-black text-black md:mb-14 md:text-3xl">
        <Translate translate-key="landing_legality.subtitle" />
      </h3>
      <ul
        class="grid list-none gap-8 p-0 md:grid-cols-2 md:gap-6"
      >
        <li
          v-for="(item, i) in legalityItems"
          :key="i"
          class="rounded-xl bg-white px-8 py-10 text-center shadow-[0px_0px_35px_rgba(0,0,0,0.08)]"
        >
          <div class="mb-6 flex justify-center">
            <NuxtImg
              :src="item.img"
              :alt="t(item.altKey)"
              :width="item.width"
              height="77"
              format="webp"
              loading="lazy"
              class="h-[77px] w-auto object-contain"
            />
          </div>
          <div
            class="innerContent prose prose-gray max-w-none text-left text-gray-700 prose-p:mb-2 prose-p:last:mb-0 [&_strong]:font-semibold"
            v-html="t(item.textKey)"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const legalityItems = [
  {
    img: "/landing/au-tradelines-are-safe-and-legal.png",
    width: 103,
    altKey: "landing_legality.image_1_alt",
    textKey: "landing_legality.text_1",
  },
  {
    img: "/landing/safety.png",
    width: 86,
    altKey: "landing_legality.image_2_alt",
    textKey: "landing_legality.text_2",
  },
];
</script>

<style scoped>
.innerContent :deep(a) {
  @apply text-teal-600 underline;
}
</style>
